import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { BiTranslateService } from "@globals/bi-translate";
import { CardModule } from "primeng/card";
import { filter, take } from "rxjs";

/**
 * Component used to show that something is unavailable or user has no access.
 * NOTE: the message to be displayed is by default the translated value of "no access".
 * To change this, use "state" object an set a "message" property in it
 */
@Component({
  selector: "unavailable",
  templateUrl: "./unavailable.component.html",
  styles: [":host { display: block; }"],
  imports: [CardModule],
  standalone: true
})
export default class UnavailableComponent {
  public message: string;

  constructor(router: Router, translator: BiTranslateService) {
    const translation = "shared.NoAccess";

    translator
      .get(translation)
      .pipe(
        filter(t => t.toUpperCase() !== translation.toUpperCase()),
        take(1)
      )
      .subscribe(t => (this.message = router.getCurrentNavigation()?.extras?.state?.message ?? t));
  }
}
